export default __webpack_public_path__ + "static/media/logo.8c0a3603.svg";